import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { gaPageChanged } from './sinks/ga4Sink';
import { analyticsRouteChanged } from '@/utils/analytics';
import { isCapabilityPath } from './urlRedact';

/** index.html sets the same on a capability route's first load. */
function setReferrerPolicy(capability: boolean): void {
    let meta = document.querySelector<HTMLMetaElement>('meta[name="referrer"]');
    if (!capability && !meta) return;
    if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'referrer';
        document.head.appendChild(meta);
    }
    // Same-origin navigations away from /share/<token> or /join#<code> carry
    // only the origin (the host's header policy sends the full URL same-origin).
    meta.content = capability ? 'strict-origin' : 'strict-origin-when-cross-origin';
}

/** Sends GA4 a redacted page_view on every client-side navigation (not the
 *  first render: index.html's gtag config sends that one). PostHog needs none:
 *  it captures history changes itself and its before_send redacts them. On a
 *  capability route (/share/*, /join) analytics stay silent and an already
 *  running PostHog pauses replay + autocapture (utils/analytics.ts). */
export function RedactedPageViews(): null {
    const { pathname, search } = useLocation();
    const first = useRef(true);
    useEffect(() => {
        setReferrerPolicy(isCapabilityPath(pathname));
        analyticsRouteChanged();
        if (first.current) {
            first.current = false;
            return;
        }
        gaPageChanged();
    }, [pathname, search]);
    return null;
}
